import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/contexts/AuthContext';
import { useGeofenceStore } from '@/stores/geofenceStore';
import type { DeviceGeofence } from '@/types';

/**
 * Geofences för användarens åtkomliga enheter, via den self-scopade RPC:n
 * get_my_device_geofences() (parameterlös — auktoriseringen sker server-side).
 * Fences ändras sällan: lång staleTime och ingen intervall-refetch; ett
 * positionssample triggar aldrig nätverksanrop.
 */
export function useMyGeofences() {
  const { user } = useAuth();
  const nearbyKeysEnabled = useGeofenceStore((s) => s.nearbyKeysEnabled);

  return useQuery({
    queryKey: ['my-geofences', user?.id],
    queryFn: async (): Promise<DeviceGeofence[]> => {
      const { data, error } = await supabase.rpc('get_my_device_geofences');
      if (error) throw error;
      return (data ?? []) as DeviceGeofence[];
    },
    enabled: !!user && nearbyKeysEnabled,
    staleTime: 5 * 60_000,
  });
}
